import Input from '../../../components/ui/Input';
import { MONO_CLASS } from '../../../components/ui/Mono';
import { SUPPLIER_CODE_MAX, SUPPLIER_DESCRIPTION_MAX } from '../../../constants/productCatalog';
import { BlingSuggestion, FieldCell, FieldInputProps, FormSection } from '../editorParts';

/**
 * Fornecedor padrão: código e descrição no fornecedor (a OC usa) e o custo
 * por unidade do SKU com até 10 casas. Custo zero é recusado: vazio = pendente.
 */
const SupplierSection = ({ ctx }) => {
    const { setField, readOnly, suggestions, capturedAt } = ctx;
    return (
        <FormSection
            id="fornecedor"
            title="Fornecedor"
            description="O código do fornecedor e o custo entram na OC; o custo também dá a margem."
        >
            <FieldCell span={2}>
                <Input
                    label="Código no fornecedor"
                    maxLength={SUPPLIER_CODE_MAX}
                    autoComplete="off"
                    className={MONO_CLASS}
                    {...FieldInputProps(ctx, 'supplier_code')}
                />
            </FieldCell>
            <FieldCell span={4}>
                <Input
                    label="Descrição no fornecedor"
                    maxLength={SUPPLIER_DESCRIPTION_MAX}
                    autoComplete="off"
                    {...FieldInputProps(ctx, 'supplier_description', {
                        hint: 'Como o fornecedor chama este item na NF dele',
                    })}
                />
            </FieldCell>
            <FieldCell span={2}>
                <Input
                    label="Custo por unidade"
                    prefix="R$"
                    inputMode="decimal"
                    placeholder="0,00"
                    autoComplete="off"
                    className={`${MONO_CLASS} text-right`}
                    {...FieldInputProps(ctx, 'cost_price', { hint: 'Até 10 casas decimais' })}
                />
                <BlingSuggestion
                    suggestion={suggestions.cost_price}
                    capturedAt={capturedAt}
                    disabled={readOnly}
                    onUse={(value) => setField('cost_price', value)}
                />
            </FieldCell>
        </FormSection>
    );
};

export default SupplierSection;
